/*
* 工单管理组件
*/

import { useState, useEffect, } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Modal,
    Button,
    Upload,
    DatePicker,
    Tag,
    Space,
    Statistic,
    theme,
    Progress,
} from 'antd';
import { PlusOutlined, ExportOutlined, ImportOutlined, LoadingOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    winWidth,
    ShowIPModal,
    isGTscreenWidth,
    rootReactDom,
    GetDropdownActionName,
    GetArrSpanMaxWidth,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';

import ProductInfo from '../../components/ProductInfo';
import WOInfo from './WOInfo.js';
import WOEntity from './WOEntity';
import WOVisitEntity from './WOVisitEntity';

const MODULENAME = CNF.navItems[2].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].submenu[0].ptn;

const { RangePicker } = DatePicker;

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,

        },
    } = theme.useToken();

    /**
     * 打印工单
     * @param {*} record 
     */
    const showWOInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <WOInfo
                colorPrimaryBg={colorPrimaryBg}
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
            />);
    }

    const shwoProductInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <ProductInfo
                colorPrimaryBg={colorPrimaryBg}
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                productNumber={record.product_number}
            />);
    }

    const visit = (record) => {
        rootReactDom && rootReactDom.render(
            <WOVisitEntity
                colorPrimaryBg={colorPrimaryBg}
                open={true}
                record={record}
                setRefresh={props.setRefresh}
            />);
    }
    const update = (record) => { props.setOpen(true, record); }


    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'wos/' + record.key;
        switch (action) {
            case CNF.actionName.VISIT:
                visit(record);
                break;
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.setRefresh, uri);
                break;
            default:
                break;
        }
    }

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '工单编号', key: 'number', fixed: 'left', width: 150,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { showWOInfo(record); }}>{record.number}</Button>
        },
        {
            title: '工单等级', key: 'level', width: 100, fixed: 'left',
            render: function (record) {
                for (let item of CNF.woLevels) {
                    if (parseInt(record.level) === parseInt(item.value)) {
                        return item.key
                    }
                }
            }
        },
        { title: '工单类型', dataIndex: 'type', key: 'type', width: 100, },
        // {
        //     title: '绩效权重', key: 'perf_weight', width: 100,
        //     render: (record) => <Tag color={colorPrimaryBg} style={{ width: '60%' }}><Statistic precision={1} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.perf_weight} /></Tag>
        // },
        { title: '所属项目', dataIndex: 'project_name', key: 'project_name', width: GetArrSpanMaxWidth(props.dataLists, 'project_name'), },
        { title: '工单点位', dataIndex: 'point', key: 'point', width: GetArrSpanMaxWidth(props.dataLists, 'point'), },
        { title: '处理开始时间', dataIndex: 'start_time', key: 'start_time', width: 200, },
        { title: '处理结束时间', dataIndex: 'end_time', key: 'end_time', width: 200, },
        {
            title: '维护支出', key: 'out_fee', width: 100,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.out_fee} /></Tag>
        },
        {
            title: '维护收入', key: 'in_fee', width: 100,
            render: (record) => <Tag color={colorSuccessBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={record.in_fee} /></Tag>
        },
        {
            title: '工单权重', key: 'perf_weight', width: 100,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '60%' }}><Statistic precision={1} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.perf_weight} /></Tag>
        },
        { title: '处理人员', dataIndex: 'do_user', key: 'do_user', width: GetArrSpanMaxWidth(props.dataLists, 'do_user', 120), },
        {
            title: '产品编码', key: 'product_number', width: 180,
            render: (record) => record.product_number ? <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { shwoProductInfo(record); }}>{record.product_number}</Button> : '-'
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_visit') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>
                        支出: <Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={props.qss?.out_fee > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={props.qss?.out_fee > 10000 ? props.qss.out_fee / 10000 : props.qss?.out_fee} /></Tag>
                        收入: <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={props.qss?.in_fee > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={props.qss?.in_fee > 10000 ? props.qss.in_fee / 10000 : props.qss?.in_fee} /></Tag>
                        共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条
                    </>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

const WO = (props) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [modal, modalContextHolder] = Modal.useModal();
    const [instance, setInstance] = useState(null);

    const [isRefresh, setIsRefresh] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [qss, setQss] = useState(null);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);

    const [projectLists, setProjectLists] = useState([]);
    const [projectUlid, setProjectUlid] = useState('');
    const [number, setNumber] = useState('');
    const [level, setLevel] = useState(0);
    const [type, setType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [doUser, setDoUser] = useState('');
    const [status, setStatus] = useState(CNF.status[0].value);

    const setRefresh = () => {
        setIsRefresh(!isRefresh);
    }

    useEffect(() => {
        /***
         * 获取项目下拉列表
         */
        const projectDDList = () => {
            const params = {
                'rss': 'list',
                'page_size': CNF.maxPageSize,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}project/bases${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        setProjectLists(data.dat);
                    }
                }
            })
        }
        projectDDList();
    }, []);

    useEffect(() => {
        /**
         * 获取列表
         */
        const getLists = () => {
            const params = {
                'number': number,
                'project_ulid': projectUlid,
                'level': level,
                'type': type,
                'start_date': startDate,
                'end_date': endDate,
                'do_user': doUser,
                'status': status,
                'page_size': CNF.pageSize,
                'current_index': currentIndex
            };
            $.ajax({
                url: `${CNF.api}wos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setDataLists(data.dat);
                            setPageCount(data.cnt);
                            setQss(data.qss);
                        } else {
                            setDataLists([]);
                            setPageCount(0);
                            setQss(null);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }
        getLists();
    }, [currentIndex, messageApi, isRefresh, number, projectUlid, level, type, startDate, endDate, doUser, status]);

    const openEntity = (value, record = null) => {
        setOpen(value);
        setRecord(record);
    }

    const create = () => { openEntity(true, null); }


    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    const uploadCheck = (info) => {
        if (info.size > 10240000) {
            message.error('上传文件超过10M，建议拆分文件！', CNF.messageDuration);
            return false
        }
        if (info.name.match(/.xls[x]{0,1}/) === null) {
            message.error('文件格式不对，只支持 xls 或 xlsx ！', CNF.messageDuration);
            return false
        }
        setInstance(modal.info({
            width: isGTscreenWidth ? 500 : 600,
            title: <Space>文件正在上传<LoadingOutlined /></Space>,
            content: <Progress percent={0} />,
            footer: null,
            icon: null,
            keyboard: false,
            closable: false,
        }));
        return true
    }

    /**
     * 更新导入弹框
     * @param {*} modal 
     * @param {*} title 
     * @param {*} data 
     * @param {*} percent 
     */
    const updateModal = (modal, title, data, percent) => {
        modal.update((prevConfig) => ({
            ...prevConfig,
            title: title,
            content: <>
                <Progress percent={percent} style={{ width: '100%' }} />
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={4}><strong>序号</strong></Col>
                    <Col span={12}><strong>工单编号</strong></Col>
                    <Col span={8}><strong>操作说明</strong></Col>
                </Row>
                <div id='import-modal-id' style={{
                    height: 360,
                    marginTop: CNF.rowMarginTop,
                    overflowY: 'auto',
                }}>
                    {
                        data.length > 0 &&
                        data.map((item, index) => {
                            return (
                                <Row style={{ lineHeight: 2 }} key={index}>
                                    <Col span={4}>{item['key']}</Col>
                                    <Col span={12}>{item['number']}</Col>
                                    <Col span={8} style={{ color: item['msg'].indexOf('成功') >= 0 ? '#000' : item['msg'].indexOf('已导入') >= 0 ? 'green' : 'red' }}>{item['msg']}</Col>
                                </Row>
                            )
                        })
                    }
                </div>
                {
                    title === '工单导入完成！' || title === '工单导入结束！' ? <div style={{ marginTop: CNF.rowMarginTop * 2, width: '100%', textAlign: 'right' }}>
                        <Button
                            title='确定'
                            variant='solid'
                            style={{ background: global.THEMECOLOR, color: '#fff', border: 0, }}
                            onClick={() => {
                                modal.destroy(); // 退出导入进度界面
                                setRefresh();
                            }}
                        >
                            确定
                        </Button></div> : ''
                }
            </>
        }));
    }

    /**
     * 获取任务
     * @param {*} modal 
     * @param {*} jobId 
     */
    const getJob = async (modal, jobId) => {
        instance.update((prevConfig) => ({
            ...prevConfig,
            title: <Space>工单正在导入<LoadingOutlined /></Space>,
            content: <Progress percent={0} />,
        }));
        let messageData = [];
        try {
            const response = await fetch(CNF.api + 'wos/lists?job_id=' + jobId,
                {
                    method: 'GET',
                    headers: AddRequestHeaders(),
                    openWhenHidden: true,
                });
            if (response.ok && response.status === 200) {
                //  连接成功
            } else {
                //  连接失败
            }
            const reader = response.body.getReader();
            const td = new TextDecoder('utf-8');
            let jsonData = null;
            while (true) {
                const { done, value } = await reader.read();
                const text = td.decode(value, { stream: true });
                if (done) {
                    // 完成, 更新进度
                    updateModal(modal, jsonData.id === jsonData.total ? '工单导入完成！' : '工单导入结束！', messageData, (parseFloat(jsonData.id / jsonData.total) * 100).toFixed(CNF.DPL));
                    break;
                }
                let jsonMatch = text.match(/data:\s*({.*?})\s*\n/);
                if (jsonMatch) {
                    jsonData = JSON.parse(jsonMatch[1]);
                } else {
                    continue;
                }
                // jsonData = JSON.parse(text.match(/data:\s*({.*?})\s*\n/)[1]);
                if (jsonData.res !== 0) {
                    // 接口返回操作不成功，退出循环
                    modal.destroy(); // 退出导入进度界面
                    messageApi.error(jsonData.msg, CNF.messageDuration);
                    break;
                }
                // 更新进度
                messageData.push(...(jsonData.data));
                updateModal(modal, <Space>工单正在导入<LoadingOutlined /></Space>, messageData, (parseFloat(jsonData.id / jsonData.total) * 100).toFixed(CNF.DPL));
                let div = document.getElementById('import-modal-id');
                if (div) {
                    div.scrollTop = div.scrollHeight;
                    div.style.scrollBehavior = 'smooth'; // 启用平滑滚动效果
                    div.scrollTo(0, div.scrollHeight); // 滚动到最底部
                }
            }
        } catch (e) {
            // 异常
            instance.update((prevConfig) => ({
                ...prevConfig,
                closable: true, // 开启关闭按钮
                onCancel: () => {
                    setRefresh();
                }
            }));
            messageApi.error('网络错误 !', CNF.messageDuration);
        }
    }

    /**
     * 执行导入
     * @param {*} info 
     */
    const upload = (info) => {
        if (info.file.status === 'uploading') {
            instance.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress percent={parseFloat(info.file.percent).toFixed(CNF.DPL)} />,
            }));
        } else if (info.file.status === 'done') {
            instance.update((prevConfig) => ({
                ...prevConfig,
                title: '文件上传完成！',
                content: <Progress percent={100} />,
            }));
            if (info.file.response.dat) {
                setTimeout(() => {
                    getJob(instance, info.file.response.dat?.job_id);
                }, 1000);

            } else {
                instance.destroy();
                messageApi.error(info.file.response.msg, CNF.messageDuration);
            }
        } else if (info.file.status === 'error') {
            modal.destroy(); // 退出导入进度界面
            messageApi.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
        }
    }

    /***
    * 导出 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '工单信息明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '工单信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '工单编号',
                    '项目名称',
                    '产品编码',
                    '工单描述',
                    '工单点位',
                    '工单等级',
                    '绩效权重',
                    '开始时间',
                    '结束时间',
                    '工单原因',
                    '处理方式',
                    '维护支出',
                    '维护收入',
                    '处理人员',
                    '工单类型',
                    '是否回访',
                    '状态',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出明细
     */
    const exportAsLists = () => {
        const params = {
            'number': number,
            'project_ulid': projectUlid,
            'level': level,
            'type': type,
            'start_date': startDate,
            'end_date': endDate,
            'do_user': doUser,
            'status': status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}wos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['project_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            for (let i of CNF.woLevels) {
                                if (parseInt(item['level']) === parseInt(i.value)) {
                                    item['level'] = i.key
                                }
                            }
                            d.push(item);
                        }
                        exportAsExcel(d);
                    } else {
                        exportAsExcel([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    return (
        <>
            {contextHolder}
            {modalContextHolder}
            <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                <Col span={isGTscreenWidth ? 2 : 3}>
                    <Input
                        placeholder='工单编号'
                        onChange={(e) => setNumber(e.target.value)}
                        value={number}
                    />
                </Col>
                <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Select
                        showSearch
                        allowClear
                        placeholder='请选择项目'
                        style={{ width: '100%' }}
                        onChange={(value) => setProjectUlid(value)}
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        options={projectLists && projectLists.map((item, index) => ({
                            key: index,
                            value: item.key,
                            label: item.name,
                        }))}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Select
                        placeholder='工单等级'
                        style={{ width: '100%' }}
                        onChange={(value) => setLevel(value)}
                        options={CNF.woLevels.map((item, index) => ({
                            key: index,
                            value: item.value,
                            label: item.key
                        }))}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Select
                        placeholder='工单类型'
                        style={{ width: '100%' }}
                        onChange={(value) => setType(value)}
                        options={CNF.woLevels.map((item, index) => ({
                            key: index,
                            value: item.value,
                            label: item.key
                        }))}
                    />
                </Col>
                <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <RangePicker
                        placeholder={['开始日期', '结束日期']}
                        style={{ width: '100%' }}
                        format='YYYY-MM-DD'
                        onChange={(_, dateString) => { setStartDate(dateString[0]); setEndDate(dateString[1]); }}
                        locale={locale}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Input
                        placeholder='处理人员'
                        onChange={(e) => setDoUser(e.target.value)}
                        value={doUser}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Select
                        allowClear
                        placeholder='状态'
                        style={{ width: '100%' }}
                        onChange={(value) => setStatus(value)}
                        value={status ? status : undefined}
                        options={CNF.status.map((item, index) => ({
                            key: index,
                            value: item.value,
                            label: item.label
                        }))}
                    />
                </Col>
                <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                    {
                        props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                            <Button
                                title={CNF.actionName.CREATE + MODULENAME}
                                color='primary'
                                variant='solid'
                                icon={<PlusOutlined />}
                                onClick={() => {
                                    create();
                                }}>
                                {CNF.actionName.CREATE}
                            </Button>
                        ) : ''
                    }
                    {
                        props.btnLists.indexOf(MODULENAME_PTN + '_import') >= 0 ? (
                            <Upload
                                action={CNF.api + 'wos/lists'}
                                headers={AddRequestHeaders(false)}
                                onChange={upload}
                                beforeUpload={uploadCheck}
                                showUploadList={false}
                                name='file'
                                accept='xlsx,xls'
                            >
                                <Button
                                    title={CNF.actionName.IMPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ImportOutlined />}>
                                    {CNF.actionName.IMPORT}
                                </Button>
                            </Upload>

                        ) : ''
                    }
                    {
                        props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                            <Button
                                title={CNF.actionName.EXPORT + MODULENAME}
                                color='primary'
                                variant='solid'
                                icon={<ExportOutlined />}
                                onClick={() => {
                                    exportAsLists();
                                }}>
                                {CNF.actionName.EXPORT}
                            </Button>
                        ) : ''
                    }
                </Space>
                <WOEntity
                    policy={props.policy}
                    preGroup={props.preGroup}
                    btnLists={props.btnLists}
                    open={open}
                    record={record}
                    setOpen={openEntity}
                    setRefresh={setRefresh}
                    projectLists={projectLists}
                />
            </Row>
            <Row>
                <Col span={24}>
                    <Lists
                        preGroup={props.preGroup}
                        btnLists={props.btnLists}
                        dataLists={dataLists}
                        currentIndex={currentIndex}
                        pageCount={pageCount}
                        qss={qss}
                        changeIndex={setCurrentIndex}
                        setOpen={openEntity}
                        setRefresh={setRefresh}
                    />
                </Col>
            </Row>
        </>
    );
}

export default WO